<template>
    <div class="row">
        <div class="col-12 col-md-12 note-head">
            <div class="note-title">
                <h4>{{ note.name }}</h4>
            </div>
            <div class="note-btn d-flex align-items-center" v-if="!note.isHideAddBtn">
                <button @click="onOpenModal(note, index)" type="button" class="btn btn-outline-primary btn-sm btn-block">
                    <i v-if="!salesOrderId" class="fas fa-plus"></i>
                    <i v-else class="fas fa-pen"></i>
                </button>
            </div>
        </div>
        <div class="col-21">
            <hr class="mt-0">
        </div>
        <div class="col-12 col-md-12 note-body">
            <div class="table-container">
                <table class="table create-billing table-width">
                    <thead>
                        <tr>
                            <th v-if="generalId"></th>
                            <th>Item Details</th>
                            <th>Doctor</th>
                            <th>Schedule</th>
                            <th>Dentition Plan</th>
                            <th>Bill Dentition</th>
                            <th>Bill Amount</th>
                            <th>Status</th>
                        </tr>
                    </thead>

                    <tbody ref="tableRef">
                        <template v-for="(item, noteIndex) in note.selectedNotes" :key="noteIndex" >
                            <tr :style="{
                                    backgroundColor: generalId == item.id ? '#bbf7d0' : '',
                                    color: generalId == item.id ? '#166534' : '',
                            }">
                                <td v-if="generalId">
                                    <button @click="onOpenTaskModal(item)" class="btn btn-outline-primary btn-sm">
                                        <i class="fas fa-plus"></i>
                                        Task
                                    </button>
                                </td>
                                <td>{{ item.name }}</td>
                                <td>{{ item.service_resource ? item.service_resource.name : '' }}</td>
                                <td>{{ item.schedule_date ? formatDate(new Date(item.schedule_date)) : '' }}</td>
                                <td>{{ item.dentition ?  item.dentition.join(", ") : ''}}</td>
                                <td>{{ getDentitionPertains(item.dentition_pertains) }}</td>
                                <td>{{ item.total }}</td>
                                <td v-html="getStatus(item.status)"></td>
                            </tr>
                            <ServiceTask 
                                v-if="item.items && item.items.length > 0" 
                                :childItems="item.items"
                                :colspan="8"
                                @onOpenEditModal="(childItem, childIndex) => onOpenEditModal(childItem, noteIndex, childIndex, item)"
                            />
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <AddTreatmentPlan
            :selectedNotes="note.selectedNotes"
            v-model:isOpenModal="isOpenModal" 
            v-if="isOpenModal"
            :dentition="dentition"
            :dentitionType="dentitionType"
        />
        <TaskModal
            v-if="store.state.isModalOpenFour"
            :selectedTask="selectedTask"
            @onSaveTask="onSaveTask"
            :editData="editData"
        />
    </div>
</template>

<script setup>
import {computed, ref} from "vue"
import { convertToTitleCase } from '@/services/utils/global';
import AddTreatmentPlan from './AddTreatmentPlan.vue';
import { formatDate } from '@/services/utils/global.js';
import {useRoute} from "vue-router";
import ServiceTask from './ServiceTask.vue';
import { useStore } from "vuex";
import TaskModal from './TaskModal.vue';

const props = defineProps({
    note: {
        type: Object,
        default: () => {}
    },
    index: {
        type: Number,
        default: -1,
    },
    salesOrderId: {
        type: Number || null,
        default: null,
    },
    generalId: {
        type: Number || null,
        default: null,
    },
    dentition: {
        type: Object || null,
        default: () => {}
    },
    dentitionType: {
        type: String || null,
        default: null,
    },
    clientId: {
        type: Number || null,
        default: null,
    }
})

const route = useRoute();
const generalId = computed(() => route.query.general_id);
const store = useStore();

const emit = defineEmits(['openModal']);
const isOpenModal = ref(false);
const selectedTask = ref(null);
const editData = ref(null);

const onOpenModal = (note, index = -1) => {
    if(note.value){
        note.name = convertToTitleCase(note.value);
    }
    
    isOpenModal.value = true
}

const onOpenEditModal = (item, index, childIndex, parentItem) => {
    editData.value = item;
    editData.value.index = index;
    editData.value.childIndex = childIndex;
    selectedTask.value = parentItem;
    selectedTask.value.client_id = props.clientId;
    store.state.isModalOpenFour = true;
}

const onSaveTask = (item) => {
    const noteItem = props.note.selectedNotes.find(note => note.id === item.activitylogable_id);
    if(! noteItem) return;

    const taskIndex = noteItem.items.findIndex(task => task.id === item.id);
    if(taskIndex !== -1) {
        noteItem.items[taskIndex] = item;
        return;
    }
    
    noteItem.items.push(item);
}

const onOpenTaskModal = (item) => {
    editData.value = null;
    selectedTask.value = item;
    selectedTask.value.client_id = props.clientId;
    store.state.isModalOpenFour = true;
}

const onRemoveNote = (noteName, selectedIndex) => {
    props.note.selectedNotes.splice(selectedIndex, 1);
}

const getStatus = (status) => {
    if(! status) return '';
    if(status === 'pending') {
        return `<span class="badge bg-warning">Ongoing</span>`;
    } else if(status === 'completed') {
        return `<span class="badge bg-success"><i class="fas fa-check"></i> Completed</span>`;
    }
}

const getDentitionPertains = (dentitionPertains) => {
    if (!dentitionPertains || dentitionPertains.length < 0) return '';
    return dentitionPertains.filter(dentition => dentition.is_billed).map(dentition => dentition.tooth_number).join(', ').toUpperCase();
}

</script>

<style scoped>
.note-title {
    min-width: 200px;
}
.note-body .card-body{
    padding: 0 2%;
}
.note-head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1%;
}
.action .close {
    color: red;
    cursor: pointer;
}
.note-body .card {
    background: #f9f9f9;
    min-height: 100px;
    margin-bottom: 1rem;
}
.medicine {
    display: flex;
    justify-content: space-between;
    margin: 3% 0;
    align-items: center;
    position: relative;
}
</style>